import _getVideoUrl from '@wix/communities-blog-universal/dist/src/utils/media/video';
import { getConfig } from './config';

export const getVideoUrl = pathname => _getVideoUrl(getConfig().videoHost)(pathname);
